import React from "react";
import {SocialPublication, SocialPublicationRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {FormModel, useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";

export const SocialPublicationEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(SocialPublicationRestControllerApiFactory);

    const form: FormModel<SocialPublication> = useForm({
        fetcher: (id) => ctrl.getSocialPublication(id),
        updater: (bean) => ctrl.saveSocialPublication(bean),
        remover: (id) => ctrl.deleteOrDismissSocialPublication(id),
        factory: () => ({} as SocialPublication),
    } as UseFormProps<SocialPublication>);

    return (
        <FormContent form={form} title={"Publicación"}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"provider"} label={"Red"} disabled/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"status"} label={"Estado"} disabled/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"externalPostId"} label={"Id externo"} disabled/>
                </Grid>
            </Grid>
            <FormInput field={"permalink"} label={"Enlace público"}/>
            <FormInput field={"error"} label={"Error (si falló)"} rows={3} disabled/>
        </FormContent>
    );
};
